import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-finance-form',
  templateUrl: './finance-form.component.html',
  styleUrls: ['./finance-form.component.css']
})
export class FinanceFormComponent implements OnInit {
  btnShow = true;
  mailsent = false;
  spinner = false;
  financeFormHide = true;
  showroomCheck: string;
  contactNumber: string;
  public financeForm = new FormGroup({
    name: new FormControl('',
      [Validators.required, Validators.minLength(3)]),
    surname: new FormControl(''),
    contactNumber: new FormControl('', [Validators.required, Validators.min(99999999), Validators.max(999999999)]),
    eMail: new FormControl('', [Validators.required, Validators.email])
  });
  calcTitle = 'Finance Calculator';
  licence = 0;
  service = 0;
  buyerType: string;
  public repaymentPeriods = [6, 12, 24, 36, 42, 48, 54, 60, 72];
  public interestRates = [];

  public calculator = {
    typesOfBuyer: [
      { name: 'individual', text: 'an individual' },
      { name: 'allowance', text: 'a car allowance buyer' },
      { name: 'company', text: 'a company' }
    ],
    vehiclePrice: 0,
    deposit: 0,
    tradeIn: 0,
    totalLoanAmount: 0,
    residualPercent: 0,
    residualCash: 0,
    interestRate: 0,
    repaymentPeriod: 0,
    totalMonthlyInstallment: 0,
    licence: this.licence,
    service: this.service
  };
  extraMoney = {
    payment: 455,
    reducedTerm: 0,
    save: 0
  };

  constructor() { }

  ngOnInit() {
    this.calculator.repaymentPeriod = 48;  // works for initial placeholder value
    this.calculator.interestRate = 15;  // works for initial placeholder value
    this.buyerType = this.calculator.typesOfBuyer[1].name;  // works for initial placeholder value
    this.interestRates = this.initialiseInterestRates();

  }

  calcServices() {
    return this.licence + this.service;
  }

  calculate(inputName) {
    this.calculateTotalLoan();
    switch (inputName) {
      case 'cash':
        this.calculateResidualPercentage();
        break;
      case 'percent':
        this.calculateResidualCash();
        break;
      default:
        this.calculateResidualCash();
        break;
    }
    if (this.calculator.totalLoanAmount === 0) {
      return;
    }
    const payments = this.calculateMonthlyInstallment(
      this.calculator.interestRate, this.calculator.repaymentPeriod, this.calculator.residualPercent, this.calculator.vehiclePrice,
      this.calculator.totalLoanAmount, this.calculator.licence, this.calculator.service);
    this.calculator.totalMonthlyInstallment = parseFloat(this.formatString(payments));
  }

  calculateTotalLoan() {
    const totalDeduction = this.calculator.deposit + this.calculator.tradeIn;
    if (totalDeduction >= this.calculator.vehiclePrice) {
      if (this.calculator.vehiclePrice > 0) {
        this.calculator.totalLoanAmount = 0;
        alert('The deposit plus trade in value is more than the new price of the vehicle, you don\'t need finance');
      }
    } else {
      this.calculator.totalLoanAmount = this.calculator.vehiclePrice + this.calcServices() - totalDeduction;
    }
  }

  calculateResidualCash() {
    if (this.buyerType === 'individual') {
      if ((this.calculator.residualPercent > 0) ||
        (this.calculator.residualCash > 0)) {
        alert('No residual allowed for individuals');
        this.clearTotals();
      }
      return;
    }
    if (this.calculator.totalLoanAmount === 0) {
      this.clearTotals();
      return;
    }
    this.calculator.residualCash = parseFloat(this.formatString(
      this.calculator.totalLoanAmount * (this.calculator.residualPercent / 100.0)
    ));
  }

  clearTotals() {
    this.calculator.residualCash = 0;
    this.calculator.residualPercent = 0;
    this.calculator.totalMonthlyInstallment = 0;
  }

  calculateResidualPercentage() {
    if (this.buyerType === 'individual') {
      alert('No residual allowed for individuals');
      this.clearTotals();
      return;
    }
    if (this.calculator.totalLoanAmount === 0) {
      this.clearTotals();
      return;
    }
    this.calculator.residualPercent =
      (this.calculator.residualCash / this.calculator.totalLoanAmount) * 100.0;
  }

  //#region Internal Methods
  initialiseInterestRates() {
    const interestRates = [];
    for (let i = 9.0; i <= 20.0; i += 0.25) {
      interestRates.push(i);
    }
    return interestRates;
  }

  calculateMonthlyInstallment(interestRate, repaymentPeriod, residualPercent, vehiclePrice, totalLoanAmount, licence, service) {
    const interest = (interestRate / 100.0) / 12;
    let paymentPerMonth = 0;
    let power = 1;
    for (let j = 0; j < repaymentPeriod; j++) {
      power = power * (1 + interest);
      const residualAmount = (residualPercent * vehiclePrice) / 100;
      const finalLoanAmount = totalLoanAmount - (residualAmount / power);
      paymentPerMonth = (finalLoanAmount * power * interest) / (power - 1);
    }
    return paymentPerMonth;
  }

  formatString(n) {
    n = Math.round(n * 100) / 100 + 0.0001;
    const numberString = '' + n;
    const index = numberString.lastIndexOf('.');
    n = numberString.substring(0, index + 3);
    if (n === 0.00) {
      return 0;
    } else {
      return n;
    }
  }
}
